import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/drivers/admin`,
});

// ✅ Get all drivers
export async function getDrivers() {
  try {
    const res = await API.get("/get-all-drivers", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Search / fetch a single driver by driverId (used by Agent Activate search box)
export async function getDriverById(driverId) {
  try {
    const res = await API.get(`/${driverId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Update driver status
export async function updateDriverStatus(driverId, status) {
  try {
    const res = await API.put(`/${driverId}/status`, { status }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Update driver status
export async function updateDriverDetails(driverId, payload) {
  try {
    const res = await API.put(`/${driverId}/details`, { payload }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}


// ✅ Upload file
export async function uploadFile(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await API.post("/upload", formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Delete file
export async function deleteFile(publicId) {
  try {
    const res = await API.delete(`/delete/${publicId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("Delete response:", res.data);
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

export async function verifyLicenceText(payload) {
  try {
    const res = await API.post(`/licence-verify-text`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}